export const isServer = import.meta.server
export const spritePaths = Object.freeze({
  "default": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-default.mo7FDIaYy7f-xfCqS2gVr0FNofLhk0DoUWTKQN3hiDI.svg",
  "sidebar": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-sidebar.CbSDxP9DhczRKlLyOmBBqJhh-oO4WFo4A6bNL8YuE90.svg",
  "leaderboard": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-leaderboard.qcETGgunkY80jFZ4ysDjDOjHhA6srSulaMfI4ujTqhM.svg"
});
export const runtimeOptions = Object.freeze({
  "ariaHidden": false
});
export const allSymbolNames = Object.freeze([
  "audio-file",
  "excel-file",
  "file",
  "image-file",
  "invoices-empty",
  "leaderboard/leaderboard-first-place",
  "leaderboard/leaderboard-second-place",
  "leaderboard/leaderboard-third-place",
  "mobile-cover",
  "pdf-file",
  "resource-empty",
  "sidebar/affiliates",
  "sidebar/affiliates-active",
  "sidebar/appointments",
  "sidebar/appointments-active",
  "sidebar/communities",
  "sidebar/communities-active",
  "sidebar/contracts",
  "sidebar/contracts-active",
  "sidebar/courses",
  "sidebar/courses-active",
  "sidebar/dashboard",
  "sidebar/dashboard-active",
  "sidebar/documents",
  "sidebar/documents-active",
  "sidebar/estimates",
  "sidebar/estimates-active",
  "sidebar/explore",
  "sidebar/explore-active",
  "sidebar/invoices",
  "sidebar/invoices-active",
  "sidebar/loyalty",
  "sidebar/loyalty-active",
  "sidebar/studio",
  "sidebar/studio-active",
  "text-file",
  "video-file",
  "word-file"
]);